import styled from "@emotion/styled";
import { BASE_COLORS, FONT_SIZES } from "../../../../../../../../../../emotion-theme";
import { withShowIf } from "../../../../../../../../../../components/with-show-if/with-show-If.component";

export const HostContainer = styled.div`
  border-radius: 50px;
  background-color: ${BASE_COLORS.white};
  border: solid 1px ${BASE_COLORS.grey};
  font-size: ${FONT_SIZES.small};
  padding: 8px;
  margin: 4px 8px 4px 0;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TextContainer = styled.div`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CategoryPillRemoveIcon = withShowIf(styled.span`
  line-height: 100%;
  margin-left: 8px;
  color: ${BASE_COLORS.grey};
  vertical-align: middle;
  &:hover {
    cursor: pointer;
  }
`);
